
import dust from "dustjs-linkedin";


(function(){dust.register("widgets/sentence",body_0);function body_0(chk,ctx){return chk.section(ctx.get(["sentence"], false),ctx,{"block":body_1},{});}function body_1(chk,ctx){return chk.reference(ctx.get(["before"], false),ctx,"h").write("<span class=\"word\">").reference(ctx.get(["word"], false),ctx,"h").write("</span>").reference(ctx.get(["after"], false),ctx,"h");}return body_0;})();

export default 0;
